export function formatDistance(distance: number | string): string {
  const parsedDistance = parseFloat(distance.toString());
  if (isNaN(parsedDistance)) {
    return '';
  }

  const formattedDistance = parsedDistance.toFixed(1).replace('.0', '').replace('.', ',');
  return formattedDistance;
}
